module.exports = new __parcel__URL__("Receptie.6f66e266.jpg").toString();